import React, { Component } from 'react';
import logo from './logo.svg';
import './App.scss';
import './NewHeader.css';
import SearchBar from './SearchBar';
import BookSearch from './BookSearch';
import GoogleBookSearch from './GoogleBookSearch'
import Quiz from './Quiz'
import WordBank from './WordBank'
import Flickr from './Flickr';
import './wordmap.css';
import config from './config';
import { AuthContext, useAuth } from './contexts/AuthContext';

// Expose config to global scope for legacy scripts (wordutil.js)
window.vxConfig = config;

function MiddlePart(props) {
  const words = props.words;
  const WB = WordBank.getGWB();
  const items = words.map((w,idx) => {
      const l = WB.db[w] || 0;
      const c = window.WL.getWLs(w).length;
      return <div key={idx} className={`content-searcherwords vx${l}`}><a href={`#${w}`}>{w}</a><span>{c}</span></div>
    
    });
  return (
    <div id="banner">
    <div className="definition">
    <ul>
    <li>
    <span>
    <div className="byline">
    meaning
    <span>|</span>
    (noun)&nbsp;
    </div>
    isolation to prevent the spread of infectious disease
    <br/>
    </span>
    </li>
    </ul>
    </div>

    <div id="banner-feature">
    <div id="chart">
    </div>
    <nav>
    <div id="tree-icon"></div>
    <div id="star-icon"></div>
    { props.isMobile && <a id="icon-next" className="next-word arrow" alt="next word" title="Next Word"></a> }
    </nav>
    </div>

    <div id="banner-side">
    <div id="banner-side-top">

    <div className="vocab-def">
    <div className={`byline sideColor ${props.pos}`}>
    Vocabulary Definition
    </div>      
    <div className="manifesto" href="">
    <span id="vocabDefs">sensational in appearance or thrilling in effect
    <br/>
    <span className="banner-side-example">"My dog was quarantined before he could live in England"</span>
    </span>
    </div>
    </div>

    <div>
    <div className={`byline sideColor ${props.pos}`}>
    Popular Definition
    </div>      
    <div className="manifesto" href="">
    <span id="banner-side-definition">sensational in appearance or thrilling in effect
    <br/>
    <span className="banner-side-example">"My dog was quarantined before he could live in England"</span>
    </span>
    </div>
    </div>

    <div className="wordlist-div">
    <div className={`byline sideColor ${props.pos}`}>
    Word Lists:
    </div>      
    <div id="wls" className="manifesto wl" href="">

    </div>
    </div>


    <div id="wordSearcherTitle" className={`byline sideColor ${props.pos}`}>{props.title}</div>      
    <div className="manifesto" href="">
    <span id="banner-side-searcher-result">
      {items}                
    </span>

    </div>


    </div>

    <div id="banner-side-bottom">   
    <a href="" className="manifesto cboxElement display-none" rel="lightbox">
    <div>
    </div>

    </a>
    </div>
    </div>          
    </div> 
    );
}


function renderDef(props) {
  return (
    <div>
    <div className="home-cat-name">Definition</div>             
    <br/>
    <div className="page-divider"></div>
    <div id="definitions">
    <div className="readmore">adj.</div>
    <span className="bold">infuriated</span>             
    <div className="entry-summary">
    <p>enforced isolation of patients suffering from a contagious disease in order to prevent the spread of disease</p>
    </div>
    <span className="content-relatedwords"><a href="#isolation">isolation</a></span>
    <br/>          
    </div> 
    </div>

    );
}

function BottomPart(props) {
  const twitter = (
    <>
    <div className="home-cat-name">Twitter</div> 
    <span id="twitter-widget"></span>    
    </>
    );
  return(
    <div id="main">
    <div className="wrap">
    <div id="content">
    <div className="hfeed">
    { !props.isMobile && 
      <div id="post-5147" className="post">                       
      { renderDef(props) }
      </div>
    }
    <div id="post-5068" className="post">
    {props.isMobile && renderDef(props)}
    <div className="home-cat-name">USAGE IN BOOKS</div>
    <div className="page-divider"></div>
    <BookSearch
    word={props.word}
    baseUrl={config.bookAPI}
    amzTag="alphabetlabs-20"
    />             

    </div>
    </div>
    </div>
    <div id="sidebar-primary" className="sidebar">
    <div className="home-cat-name">USAGE IN BOOKS  </div> 
    <br/>

    <div className="page-divider"></div>
    <GoogleBookSearch
    word={props.word}
    baseUrl="https://52.9.182.134:3000"
    amzTag="alphabetlabs-20"
    />

  {/*<Flickr word={props.word}/>*/}
  </div>
  </div>
  </div>
  );
}
function OldHeader() {
  return (
    <div className="App-header">
    <span className="App-header-name">dictionaryX</span>
    <span className="App-header-caption">The Fastest, Free & Fun Dictionary & Thesaurus</span>
    </div>
    );
}

function AccountButton() {
  const { currentUser, logout, handleGoogleLogin } = useAuth();
  const googleButtonRef = React.useRef(null);

  React.useEffect(() => {
    // Initialize Google Sign-In button when not logged in
    if (!currentUser && window.google && googleButtonRef.current) {
      window.google.accounts.id.initialize({
        client_id: '302079354234-2qqi2h78b30tq5hcr7aoaq281oc98f82.apps.googleusercontent.com',
        callback: async (response) => {
          try {
            await handleGoogleLogin(response.credential);
          } catch (error) {
            console.error('Login failed:', error);
            alert('Login failed. Please try again.');
          }
        }
      });

      window.google.accounts.id.renderButton(
        googleButtonRef.current,
        {
          theme: 'outline',
          size: 'medium',
          text: 'signin_with',
          shape: 'rectangular'
        }
      );
    }
  }, [currentUser, handleGoogleLogin]);

  if (currentUser) {
    return (
      <div className="user-profile-container">
        <img className="user-avatar" src={currentUser.picture} alt={currentUser.name} title={currentUser.name} />
        <button className="logout-button" onClick={logout}>Log out</button>
      </div>
    );
  } else {
    return (
      <div style={{display:'flex', alignItems: 'center', gap: '10px'}}>
        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
          <button className="round-button donate-button">
            Buy Us a Cookie <img src="common/img/32420-cookie-icon.png" height="20" alt="cookie"/>
          </button>
          <input type="hidden" name="cmd" value="_s-xclick" />
          <input type="hidden" name="hosted_button_id" value="PR2EXDT5TME4A" />
          <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
        </form>
        <div ref={googleButtonRef}></div>
      </div>
    );
  }
}

// Fisher-Yates shuffle algorithm
function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
}

class App extends Component {
  static contextType = AuthContext;
  static NMASTERED_IN_REVIEW = 10;

  constructor(props) {
    super(props);
    // Get the initial word from wordmap that was already initialized in index.html
    // wordmap has already called lookup() with the initial word, so we just read it
    const initWord = (window.wm && window.wm.word) ? window.wm.word : '';

    this.state = {
      wlIdx: 0,
      qType: 'mix',
      qMode: 'mix',
      reviewMode: true,
      isQuizMode: false,
      lastUpdate: new Date(),
      showMax: 20,
      word:'',
      lword: initWord,
      suggestions:[],
      questions:[
            {
              q1:
                "What is the word that means the lofty nest of a bird of prey (such as a hawk or eagle)",
              choices: ["aerie", "icon", "fowl", "quary"],
              a: 0
            },
            {
              q1: "What is the word that means the act of entering",
              choices: ["angst", "ingress", "obscure", "stipulate"],
              a: 1
            }
          ],
      count:0,
      rawWords:[],
      googleUser:null,
      wordListName: props.wordListName
    };
    this.lookup = this.lookup.bind(this);
    this.onChange = this.onChange.bind(this);
    this.updateQuizQuestionFromWordlist = this.updateQuizQuestionFromWordlist.bind(this);
    this.skipTwenty = this.skipTwenty.bind(this);
    this.refreshQMode = this.refreshQMode.bind(this);
    setInterval(() => {
      const count = this.state.word === '' ? window.WL.getWordList(this.state.wordListName).length : this.state.rawWords.length;
      const now = new Date();
      const diff = now.getTime()-this.state.lastUpdate.getTime();
      if (diff > 1000 && this.state.showMax < 100 && this.state.showMax < count) {
        this.setState({'showMax':100});
      }
      if (diff > 4000 && this.state.showMax <1000 &&this.state.showMax < count) {
        this.setState({'showMax':1000})
      }
      if (diff > 8000 && this.state.showMax <10000 &&this.state.showMax < count) {
        this.setState({'showMax':10000})
      }        
    }, 1000);
  }
  componentDidMount() {
    // Initialize quiz questions
    this.updateQuizQuestionFromWordlist();

    // Listen for WordBank sync events (after login)
    this.handleWordbankSynced = () => {
      console.log('WordBank synced, refreshing quiz data...');
      this.updateQuizQuestionFromWordlist();
    };
    window.addEventListener('wordbank-synced', this.handleWordbankSynced);

    // Multi-device sync: Sync when tab becomes visible
    this.handleVisibilityChange = () => {
      if (!document.hidden && this.context.isAuthenticated) {
        console.log('Tab visible, syncing from server...');
        WordBank.syncFromServer();
      }
    };
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    // Multi-device sync: Periodic sync (60 mins for prod, 3 mins for dev)
    if (this.context.isAuthenticated) {
      const syncIntervalMs = process.env.NODE_ENV === 'production' ? 3600000 : 180000; // 60 mins for prod, 3 mins for dev
      this.syncInterval = setInterval(() => {
        console.log('Periodic sync triggered...');
        WordBank.syncFromServer();
      }, syncIntervalMs);
    }

    // Google OAuth will be handled by the new Google Identity Services
    // through the AuthContext and AccountButton component

    // Ensure graph is rendered on initial page load
    setTimeout(() => {
      if (window.wm) {
        window.wm.refresh();
      }
    }, 100);
  }

  componentWillUnmount() {
    // Clean up event listeners
    if (this.handleWordbankSynced) {
      window.removeEventListener('wordbank-synced', this.handleWordbankSynced);
    }
    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    // Clean up periodic sync interval
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
    }
  }
  lookup(word) {
   if (window.wm) {
    window.wm.lookup(word); 
   }
   
   this.setState({
    word:'',
    lword:word,
    rawWords:[],
    suggestions:[],
    count:0
  });
 }

 onChange(evt) {

  var word = evt.target.value;
  this.setState({
    showMax: 20,
    lastUpdate: new Date(),
    word: word,
    count: this.state.count+1,
  });
  if (word.length === 0) {
    this.setState({
      suggestions: []
    });
    return;
  }
  if (this.props.isMobile) return;
    const url = `${config.dictAPI}/graph/${word}`;
    // console.log(`fetching ${url}`);
    fetch(url)
    .then(resp => resp.json())
    .then(data => {
        // console.log(`data ${data}`);
        // var list = data.rawWords || [];
        var list = [];
        if (list) {
          list = list.slice(0,10);
        }
        this.setState({
          rawWords: data.rawWords,
          suggestions: this.state.count === 0? [] :list,
          count:this.state.count > 0 ? this.state.count - 1 : 0
        });  
      }); 
  }

  updateQuizQuestionFromWordlist(cb) {
    this._updateQuizQuestionFromWordlist(cb,false);
  }

  refreshQMode() {
    this._updateQuizQuestionFromWordlist(()=>this.quiz.refresh(),false);
  }

  skipTwenty(cb) {
    this._updateQuizQuestionFromWordlist(cb, true);
  }

  _updateQuizQuestionFromWordlist(cb, skipTwenty) {
    const allWords = shuffle([...window.WL.getWordList(window.WL.getName())]);
    const wb = new WordBank();
    const WB = WordBank.getGWB();
    const words = [];
    const NWORD_IN_QUIZ = 20;
    let c = 0;
    let { wlIdx, reviewMode } = this.state;
    if (skipTwenty) {
      for (; wlIdx < allWords.length; wlIdx++) {
        const w = allWords[wlIdx];
        const s = WB.getScore(w);
        if (s<5) {
          if (++c>=NWORD_IN_QUIZ) break;
        }
      }
    }
    const startIdx = wlIdx;
    c=0;
    for (; wlIdx < allWords.length; wlIdx++) {
      const w = allWords[wlIdx];
      const s = WB.getScore(w);
      // Only add non-mastered words (score < 5)
      if (s < 5) {
        wb.addWord(w, s);
        words.push(w);
        if (++c>=NWORD_IN_QUIZ) break;
      }
    }

    // Add mastered words for review mode
    if (reviewMode) {
      const masteredWords = allWords.filter(w => WB.getScore(w) === 5);
      // Shuffle and take up to 10 mastered words
      const reviewWords = shuffle([...masteredWords]).slice(0, App.NMASTERED_IN_REVIEW);
      reviewWords.forEach(w => {
        wb.addWord(w, 5);
        words.push(w);
      });
    }

    WordBank.getDefs(words).then(qMap => {
      if( skipTwenty) {
        this.setState({qMap, wbDb:wb.db,wlIdx: startIdx},cb);
      } else {
        this.setState({qMap, wbDb:wb.db},cb);
      }

    })


  }
  render() {
    const {isMobile} = this.props;
    const { showMax, word, rawWords, wordListName, x, y, wbDb} = this.state;
    const { isQuizMode, qMap, qType, qMode } = this.state;
    const isGREWordList = wordListName.substr(0,3) === "GRE";
    const total = word === '' ? window.WL.getWordList(wordListName).length : rawWords.length;
    const words = word === ''
      ? window.WL.getWordList(wordListName).slice(0,showMax)
      : rawWords.slice(0,showMax);
    let percent = (100*words.length / total);
    let midTitle = word === ''
    ? `WORD LIST: ${wordListName} ` + (isGREWordList ? '' : `(${words.length})`)
    : `${this.state.rawWords.length} "${word}" matches`;
    if (percent < 100) {
      midTitle = `${Math.round(percent)}% of ${midTitle}`;
    }

    const content = isQuizMode ? (
      <Quiz
      ref={(ref) => {this.quiz = ref }}
      wbDb={wbDb}
      qMap={qMap}
      qType={qType}
      qMode={qMode}
      reviewMode={this.state.reviewMode}
      numMasteredWords={App.NMASTERED_IN_REVIEW}
      setReviewMode={(reviewMode) => {
        this.setState({reviewMode}, this.refreshQMode);
      }}
      skipTwenty={this.skipTwenty}

      onAnswer={(wbDb) => {
        console.log("update wbDb " + JSON.stringify(wbDb));
        this.setState({wbDb});
      }}
    ></Quiz> 
    ):
    (
      <>
      <MiddlePart isMobile={isMobile} pos={this.state.pos} title={midTitle} words={words}/>
      <BottomPart isMobile={isMobile} word={this.state.lword} value="1"/>
      <div className="Graph"/>
      <div className="SideBar"/>
      <div className="Footer'"/>
      </>
      )

    return (
      <div className="App">
      <div className="App-header-holder">
      <div className="App-header">
      <span className="App-header-name">Vx</span>
      <AccountButton />
      </div>
      <SearchBar value="1" isMobile={isMobile} isQuizMode={isQuizMode}
      lookup={this.lookup}
      setWordListName={ name => {
        window.wm.setWordList(name);
        this.setState({wordListName:name,wlIdx:0});
        this.lookup(window.WL.getNext());
        this.updateQuizQuestionFromWordlist();
      }}

      setQType={ qType => {
        this.setState({qType}, this.refreshQMode);
      }}
      setQMode={ qMode => {
        this.setState({qMode}, this.refreshQMode);
      }}
      skipTwenty={()=>this.skipTwenty(null)}

      toggleQuiz={() => {
        this.setState(prevState => ({isQuizMode: !prevState.isQuizMode}), () => {
          setTimeout(() => {
            window.wm.refresh();
          }, 500);
        });
      }}
      
      wordListMenu={this.props.wordListMenu}
      wordListName={this.state.wordListName}
      wordListNames={this.props.wordListNames}
      data={this.state.suggestions} 
      word={this.state.word} 
      onChange={this.onChange}/>
      </div>
      {content}


      </div>
      );
  }
}

export default App;
